import React from 'react';
const IconActionEmailFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 8.58V20H22V8.58L12 14.35L2 8.58ZM2 4V6.27L12 12L22 6.27V4H2Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconActionEmailFill;